import { render, staticRenderFns } from "./feedback-dialog.vue?vue&type=template&id=5ded78a7"
import script from "./feedback-dialog.vue?vue&type=script&lang=js"
export * from "./feedback-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports